import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import * as dateutil from '@appbase/util/date-helper';

@Component
export default class ArticleViewLogList extends Vue {
    @Prop({ type:Array }) articleViewLogList!: article.ViewLogSet[]

    fnSetDisplayDate(date: string){
        var displayDate = dateutil.uGetDateFormat('yyyy-MM-DD H:i', new Date(date));
        return displayDate;
    }
}